import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-analytics-time-selector',
  templateUrl: './analytics-time-selector.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AnalyticsTimeSelectorComponent implements OnInit {
  @Input() disabled = false;

  @Output() selectedOptionChange = new EventEmitter<string>();

  selectedOption = '1d';

  isOpen = signal(false);

  optionList = [
    { value: '1d', viewValue: 'Last 24 hours' },
    { value: '1w', viewValue: 'Last 7 days' },
    { value: '2w', viewValue: 'Last 14 days' },
    { value: '1m', viewValue: 'Last month' },
  ];

  get selectedLabel(): string {
    return (
      this.optionList.find((o) => o.value === this.selectedOption)?.viewValue ??
      ''
    );
  }

  ngOnInit(): void {
    this.selectedOptionChange.emit(this.selectedOption);
  }

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    if (!this.disabled) this.isOpen.update((v) => !v);
  }

  select(value: string, event: MouseEvent): void {
    event.stopPropagation();
    this.selectedOption = value;
    this.isOpen.set(false);
    this.selectedOptionChange.emit(value);
  }

  @HostListener('document:click')
  close(): void {
    this.isOpen.set(false);
  }
}
